/**
 * Global Logger Utility attached to `window.myUtility` and `window.log`
 * Allows zero-import logging across the entire app.
 */

const isDebugEnabled = () => {
  try {
    // 1. Always enable in development mode
    // if (process.env.NODE_ENV !== 'production') {
    //   return true;
    // }

    // 2. Check Cookie '__debug=true'
    if (typeof document !== 'undefined' && document.cookie.includes('__debug=true')) {
      return true;
    }

    // 3. Check LocalStorage
    if (typeof window !== 'undefined' && window.sessionStorage) {
      if (sessionStorage.getItem('__debug') === 'true' || sessionStorage.getItem('debug') === 'true') {
        return true;
      }
    }

    // 4. Check URL query parameter (e.g. app.com/dashboard?__debug=true)
    if (typeof window !== 'undefined' && window.location) {
      const params = new URLSearchParams(window.location.search);
      if (params.get('__debug') === 'true' || params.get('debug') === 'true') {
        sessionStorage.setItem('__debug', 'true');
        return true;
      }
    }
  } catch (error) {
    // Fallback if browser storage/cookie access fails
  }

  return false;
};

const loggerUtility = {
  log: (...args) => {
    if (isDebugEnabled()) {
      console.log("[DEBUG] |", ...args);
    }
  },
  info: (...args) => {
    if (isDebugEnabled()) {
      console.info('[INFO]', ...args);
    }
  },
  warn: (...args) => {
    if (isDebugEnabled()) {
      console.warn('[WARN]', ...args);
    }
  },
  error: (...args) => {
    if (isDebugEnabled()) {
      console.error('[ERROR]', ...args);
    }
  },
  table: (...args) => {
    if (isDebugEnabled()) {
      console.table(...args);
    }
  },
  enableDebug: () => {
    // document.cookie = '__debug=true; path=/; max-age=31536000';
    sessionStorage.setItem('__debug', 'true');
    console.log('%c Debug mode ENABLED ', 'background: #222; color: #bada55; font-size: 14px; font-weight: bold;');
  },
  disableDebug: () => {
    // document.cookie = '__debug=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    sessionStorage.removeItem('__debug');
    sessionStorage.removeItem('debug');
    console.log('%c Debug mode DISABLED ', 'background: #222; color: #ff5555; font-size: 14px; font-weight: bold;');
  }
};

// Attach to window object globally
if (typeof window !== 'undefined') {
  window.myUtility = loggerUtility;
  window.log = loggerUtility.log;
}

export default loggerUtility;
